
import baseURL from "../config";
import {
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    NativeSelect,
    useTheme,
    Select,
  MenuItem
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import Header from "../Components/Header";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { tokens } from "../theme";
  import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
  import { useEffect, useState } from "react";
  import * as React from "react";
  import Radio from "@mui/material/Radio";
  import RadioGroup from "@mui/material/RadioGroup";
  import FormControlLabel from "@mui/material/FormControlLabel";
  import Cookies from "js-cookie";
  import CryptoJS from "crypto-js";

  
  const PosForm = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isTablet = useMediaQuery("(min-width:1175px");
    const colors = tokens(theme.palette.mode);
    const notifyError = () => toast.error("This brand doesn't exist");
    const [brands, setBrands] = useState([]); 
    const getDecryptedToken = () => {
      const encryptedToken = Cookies.get("token");
      if (!encryptedToken) return null;
  
      const secretKey = '19092002'; 
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
      const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
  
      return decryptedToken || null;
    };
  
   
    const token = getDecryptedToken();


    const navigate = useNavigate();
    // const [isFeeActive, setIsFeeActive] = useState(true);
    // const [clientStatus, setClientStatus] = useState(true)
  
    // const handleStatusChange = (event) =>{
    //   setClientStatus(event.target.value == "true");
    // }
    // const handleRadioChange = (event) => {
    //   setIsFeeActive(event.target.value === "true");
    // };



  useEffect(() => {
    
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/Brands/GetBrands`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if(response.data.success){
            const brands = response.data.brands;
        setBrands(brands);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, [token]);
  
    const handleFormSubmit = async (values, actions) => {
        try {
           
            await axios.post(
              `${baseURL}/api/PointOfSale/CreatePOS`,
              {
                posid: values.PosId,
                name: values.Name,
                brandId: values.BrandId,
                longitude: values.Longitude,
                latitude: values.Latitude,
                location: values.Location,
                website: values.Website,
                address: values.Address,
                phone: values.Phone,
                workingHours: values.WorkingHours,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, 
                },
              }
            );
        navigate("/pos");
      } catch (error) {
        if (error.response) {
       
          actions.resetForm();
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      }
    };
    const style = {
      radiobutton: {
        float: "right",
      },
    };
  
    return (
      <Box m="20px">
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <Header title="Shto Pike te shitjes" subtitle="Plotesoni te dhenat per Piken e shitjes" />
        <Link to="/pos" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
          >
            <KeyboardReturnOutlinedIcon />
            Tabela e Pikave te shitjes
          </Button>
        </Link>
  
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setValues,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="POS Id"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.PosId}
                  name="PosId"
                  error={!!touched.PosId && !!errors.PosId}
                  helperText={touched.PosId && errors.PosId}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Name}
                  name="Name"
                  error={!!touched.Name && !!errors.Name}
                  helperText={touched.Name && errors.Name}
                  sx={{ gridColumn: "span 2" }}
                />
                <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel>ID e Brendit</InputLabel>
                <Select
                  value={values.BrandId}
                  onChange={(e) => setFieldValue("BrandId", e.target.value)}
                  onBlur={handleBlur}
                  name="BrandId"
                  error={!!touched.BrandId && !!errors.BrandId}
                >
                  {brands.map((brand) => (
                    <MenuItem key={brand.brandId} value={brand.brandId}>
                      {`${brand.brandId} - ${brand.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
                <TextField
                  fullWidth
                  variant="filled"
                  
                  label="Latitude"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Latitude}
                  name="Latitude"
                  error={!!touched.Latitude && !!errors.Latitude}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                
                  label="Longitude"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Longitude}
                  name="Longitude"
                  error={!!touched.Longitude && !!errors.Longitude}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Location"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Location}
                  name="Location"
                  error={!!touched.Location && !!errors.Location}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Address}
                  name="Address"
                  error={!!touched.Address && !!errors.Address}
                  sx={{ gridColumn: "span 1" }}
                />
  
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Phone"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Phone}
                  name="Phone"
                  error={!!touched.Phone && !!errors.Phone}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Working Hours"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.WorkingHours}
                  name="WorkingHours"
                  error={!!touched.WorkingHours && !!errors.WorkingHours}
                  sx={{ gridColumn: "span 1" }}
                />
                
                <Box sx={{ gridColumn: "span 4" }}>
                  {" "}
                  <hr
                    style={{
                      border: "none",
                      height: "2px",
                      backgroundColor: "white",
                      margin: "0",
                      padding: "0",
                    }}
                  />
                </Box>
               
  
             
             
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" style={{ backgroundColor: colors.primary[700]}} variant="contained">
                Shto POS
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  };
  
  
  const checkoutSchema = yup.object().shape({
    PosId: yup.number().required("POS Id is required!"),
    Name: yup.string().required("Name is required!"),
    BrandId: yup.string().required("Brand is required!"),
    Longitude: yup.number().required("Longitude is required!"),
    Latitude: yup.number().required("Latitude is required!"),
    Location: yup.string().required("Location is required!"),
    Website: yup.string().url("Must be a valid URL").nullable(),
    Address: yup.string().required("Address is required!"),
    Phone: yup.string().required("Phone is required!"),
    WorkingHours: yup.string().required("Working Hours are required!"),
  });
  
  const initialValues = {
    PosId: 0,
    Name: "",
    BrandId: "",
    Longitude: 0,
    Latitude: 0,
    Location: "",
    Website: "",
    Address: "",
    Phone: "",
    WorkingHours: "",
  };
  
  
  export default PosForm;